// react
// @ts-nocheck
import { useState, useEffect, useRef } from "react";
import jwt_decode from 'jwt-decode';
import { useCookies } from 'react-cookie';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

import '../../css/normalize.css';
import '../../css/App.css';

import departmentWpJson from '../../files/wp_info_department.json';
import buildingWpJson from '../../files/wp_building.json';

function CompanyEventList() {
  const [cookies] = useCookies(['sessionToken']);
  const [loginData, setLoginData] = useState({});
  const [cookieJti, setCookieJti] = useState('');
  const [departmentWpAll] = useState(departmentWpJson);
  const [buildingWp] = useState(buildingWpJson);
  const [departmentIds, setDepartmentIds] = useState([]);
  const [buildingParam, setBuildingParam] = useState('');
  const [events, setEvents] = useState([]);
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  const swiperRef = useRef(null);

  const urlBase = process.env.REACT_APP_WP_REST_API_PATH_INFO || 'https://yourdomain.jp/info/';
  const baseUrl = process.env.REACT_APP_PUBLIC_URL || 'https://yourdomain.jp';
  const [shouldShowNav, setShouldShowNav] = useState(false);

  const [isReady, setIsReady] = useState(false);


  useEffect(() => {
    if (cookies.sessionToken) {
      const decoded = jwt_decode(cookies.sessionToken);
      setLoginData(decoded.data);
      setCookieJti(decoded.jti);
    }
  }, []);

  useEffect(() => {
    if (Object.keys(loginData).length > 0) {
      getParameter();
    }
  }, [loginData]);

  useEffect(() => {
    if (departmentIds.length > 0 && cookieJti) {
      fetchEvents();
    }
  }, [departmentIds, cookieJti]);

  // マッチハイト
  useEffect(() => {
    if (events.length > 0) {
      const timer = setTimeout(() => {
        if (window.$ && typeof window.$.fn.matchHeight === 'function') {
          window.$('.event_title').matchHeight({ byRow: false });
          window.$('.event_sub.entry_method').matchHeight({ byRow: false });
          window.$('.event_overview').matchHeight({ byRow: false });
        }

        // 表示フラグを true にする（高さ調整完了後）
        setIsReady(true);
      }, 200); // 速すぎてもDOM未構築の可能性があるので適度に遅延

      return () => clearTimeout(timer);
    }
  }, [events]);


  useEffect(() => {
    const handleResize = () => {
      if (window.$ && typeof window.$.fn.matchHeight === 'function') {
        window.$('.event_title').matchHeight({ byRow: false });
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  function getParameter() {
    if (loginData.BUILDING_SLUG !== 'inBuilding') {
      const excludeBuildingId = buildingWp[0].id;
      setBuildingParam(`&event_building_exclude=${excludeBuildingId}`);
    }

    let departmentSlug = loginData.SECTION_SLUG3 || loginData.SECTION_SLUG2 || loginData.SECTION_SLUG1 || loginData.DEPARTMENT_SLUG || loginData.OFFICE_SLUG || 'all';
    departmentSlug = departmentSlug.toLowerCase();
    let wpDepartment = departmentWpAll.find(v => v.slug === departmentSlug) || departmentWpAll.find(v => v.slug === 'all');
    setDepartmentIds(wpDepartment.ancestors_ids);
  }

  async function fetchEvents() {
    const paramPost = `/wp-json/wp/v2/event?event_department=${departmentIds}${buildingParam}&per_page=100`;
    const dynamicUrl = urlBase + paramPost + `&zenken=${cookieJti}`;

    try {
      const res = await fetch(dynamicUrl);
      if (!res.ok) throw new Error('取得失敗');
      const data = await res.json();

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const filteredData = data.filter(event => {
        const eventDateStr = event.acf?.event_date;
        const endTimeStr = event.acf?.end_event_time;
        if (!eventDateStr) return false;

        const eventDate = new Date(eventDateStr);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        eventDate.setHours(0, 0, 0, 0);

        const isToday = eventDate.getTime() === today.getTime();

        if (isToday && endTimeStr) {
          const [endHour, endMinute] = endTimeStr.split(':').map(Number);
          const now = new Date();
          const eventEndDateTime = new Date(eventDateStr);
          eventEndDateTime.setHours(endHour, endMinute, 0, 0);

          if (now > eventEndDateTime) {
            // 当日、かつ終了時間を過ぎていれば非表示
            return false;
          }
        }

        // 本日以降（または本日かつ終了時間未満）は表示
        return eventDate >= today;
      });


      const sortedData = filteredData.sort((a, b) => {
        const aDate = a.acf?.event_date || '1970-01-01';
        const bDate = b.acf?.event_date || '1970-01-01';

        const aTime = a.acf?.start_event_time || '00:00';
        const bTime = b.acf?.start_event_time || '00:00';

        // 日付比較
        if (aDate < bDate) return -1;
        if (aDate > bDate) return 1;

        // 同じ日なら時間を分解して比較
        const [aHour, aMinute] = aTime.split(':').map(Number);
        const [bHour, bMinute] = bTime.split(':').map(Number);

        if (aHour !== bHour) return aHour - bHour;
        return aMinute - bMinute;
      });

      console.table(sortedData.map(e => ({
        id: e.id,
        date: e.acf?.event_date,
        time: e.acf?.start_event_time,
        title: e.title?.rendered
      })));

      setEvents(sortedData);
    } catch (e) {
      console.error('イベント情報取得エラー:', e);
    }
  }

  function doDateFormat(date) {
    const d = new Date(date);
    return `${d.getFullYear()}/${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getDate()).padStart(2, '0')}`;
  }

  function getEventLabel(eventDateStr) {
    if (!eventDateStr) return null;

    const today = new Date();
    const eventDate = new Date(eventDateStr);
    today.setHours(0, 0, 0, 0);
    eventDate.setHours(0, 0, 0, 0);

    const diffDays = (eventDate - today) / (1000 * 60 * 60 * 24);

    if (diffDays === 0) return '本日開催';
    if (diffDays === 1) return '明日開催';
    if (diffDays > 1) return '';
    return null;
  }

  return (
    <>
      <div className="icon-title-area kaigisitu">
        <h2 className="icon-title type-event mb-0">開催間近の社内外イベント</h2>
        <div className="icon-title-sub-sub">※社員が参加可能なイベントのみ</div>
      </div>
      <div className={`event_wrap ${!isReady ? 'is-loading' : 'is-loaded'}`}>
        {events.length > 0 ? (
          <>
            <div className="swiper-wrapper-with-controls position-relative">
              <Swiper
                ref={swiperRef}
                slidesPerView={4}
                spaceBetween={20}
                slidesPerGroup={4}
                onSwiper={(swiper) => {
                  swiperRef.current = swiper;
                  const slideLength = swiper.slides.length;
                  const visibleSlides = swiper.params.slidesPerView;
                  setShouldShowNav(slideLength > visibleSlides);
                }}
                onSlideChange={(swiper) => {
                  setIsBeginning(swiper.isBeginning);
                  setIsEnd(swiper.isEnd);
                }}
                navigation={false}
                modules={[Navigation]}
                breakpoints={{
                  1024: { slidesPerView: 4, slidesPerGroup: 4 },
                  768: { slidesPerView: 2, slidesPerGroup: 2 },
                  0: { slidesPerView: 1, slidesPerGroup: 1 }
                }}
              >
{events.map((event, index) => {
  const acf = event.acf || {};
  const eventDate = acf.event_date ? doDateFormat(acf.event_date) : '';
  const eventTime = acf.start_event_time && acf.end_event_time ? `${acf.start_event_time}-${acf.end_event_time}` : '';
  const eventTarget = acf.event_target || '';
  const eventSpace = acf.event_space || '';
  const eventOrganized = acf.event_organized || '';
  const eventOverview = acf.event_overview || '';
  const thumbnailUrl = event.featured_image_src;
  const eventLabel = getEventLabel(acf.event_date);

  const hasUrl = !!acf.event_url;
  const CardTag = hasUrl ? 'a' : 'div';

  return (
    <SwiperSlide key={event.id}>
      <CardTag
        {...(hasUrl
          ? {
              href: acf.event_url,
              target: "_blank",
              rel: "noopener noreferrer"
            }
          : {})}
        className={`event_card ${index === 4 ? "half-visible-slide" : ""}`}
      >
        {thumbnailUrl && (
          <div className="event_thumbnail">
            <img
              src={thumbnailUrl}
              alt="イベントサムネイル"
              className={index === 4 ? "half-thumbnail" : ""}
            />
          </div>
        )}
        <div className="event_content_main">
          <div className="event_notice_area">
            {eventLabel && (
              <div
                className={`soon-label ${
                  eventLabel === '本日開催'
                    ? 'label-today'
                    : eventLabel === '明日開催'
                    ? 'label-tomorrow'
                    : 'label-upcoming'
                }`}
              >
                {eventLabel}
              </div>
            )}
          </div>
          <p
            className="event_title"
            dangerouslySetInnerHTML={{ __html: event.title.rendered }}
          ></p>
        </div>
        <div className="event_date_area">
          <div className="event_date">{eventDate} {eventTime}</div>
        </div>
        <div className="event_content">
          <div className="event_main">
            <div className="event_datail">
              <p className="event_label">対象範囲</p>
              {eventTarget && <p className="event_sub">{eventTarget}</p>}
            </div>
            <div className="event_datail">
              <p className="event_label target">参加方法</p>
              {eventSpace && <p className="event_sub entry_method">{eventSpace}</p>}
            </div>
            <div className="event_datail">
              <p className="event_label entry">主催者</p>
              {eventOrganized && <p className="event_sub entry_method">{eventOrganized}</p>}
            </div>
            {eventOverview && <p className="event_overview">{eventOverview}</p>}
          </div>
        </div>
      </CardTag>
    </SwiperSlide>
  );
})}
              </Swiper>
              {shouldShowNav && (
                <>
                  <div
                    className={`btn-slide btn-slide-prev ${isBeginning ? 'disabled' : ''}`}
                    onClick={() => swiperRef.current.slidePrev()}
                  />
                  <div
                    className={`btn-slide btn-slide-next ${isEnd ? 'disabled' : ''}`}
                    onClick={() => swiperRef.current.slideNext()}
                  />
                </>
              )}
            </div>
          </>
        ) : (
          <p>イベントはありません。</p>
        )}
      </div>
    </>
  );
}

export default CompanyEventList;
